// src/components/quotes/quoteBuilder.js
//
// Opening the quote builder from ANYWHERE in the app.
//
// ⚠ THE TRAP THIS EXISTS FOR. The quote builder modal is rendered INSIDE
// `{tab === "quoting" && …}` in MspOsApp. Setting `editingQuoteId` while the
// user is on another tab therefore creates the quote and shows nothing at all —
// the button reads as broken, and the quote is only discovered later sitting in
// the list. That is exactly what "Create quote" on a roadmap item did, because
// it is driven from the Monthly Reports tab.
//
// `convertBacklogToQuote` gets away with setting only `editingQuoteId` because
// it is already ON the quoting tab. Any NEW entry point is not, so the rule is
// stated here once rather than left as a comment for each caller to remember.
//
// Kept React-free so it can be unit-tested — the same reason quoteRecord.js is.

/** The tab the builder modal lives on. ⚠ "quoting", NOT "quotes". */
export const QUOTE_BUILDER_TAB = "quoting";

/**
 * What has to change for a newly created quote to actually be SEEN.
 *
 * Returns the id to open and the tab to be on. `tabChanged` is false when the
 * caller is already there, so an entry point on the quoting tab does not do a
 * redundant state write — but the target tab is returned either way, so a
 * caller can simply apply it without branching.
 */
export function planQuoteOpen({ quoteId, currentTab } = {}) {
  if (!quoteId) {
    throw new Error("planQuoteOpen needs the id of the quote to open.");
  }
  return {
    editingQuoteId: quoteId,
    tab: QUOTE_BUILDER_TAB,
    tabChanged: currentTab !== QUOTE_BUILDER_TAB,
  };
}
